<template>
  <TemplateBasic cloud>
    <template v-slot:body>
    <div class="wrap overflow tleft-child">
      <h1 class="big-title col-vbspace">Conditions générales de vente</h1>

      <p>
        Les présentes conditions générales de vente
        concernent le site de vente en ligne : www.widddi.com
      </p>
      <p>Acceptation des conditions de ventes</p>
      <p>
        Les conditions générales de ventes détaillées ci-dessous régissent
        les relations contractuelles entre tout utilisateur du site widddi.com
        (ci-après désigné un “Utilisateur” ou “Vous” ou “Acheteur”) et la société Widddi.
        Ces conditions générales de vente sont les seules applicables et remplacent
        toutes autres conditions, sauf dérogation préalable, expresse et écrite.
        Widddi peut être ponctuellement amenée à modifier certaines des dispositions
        de ses conditions générales, aussi il est nécessaire que celles-ci soient
        relues avant chaque visite du site widddi.com(ci-après désigné le “site “).
        Ces modifications sont opposables à compter de leurs mises en ligne et
        ne peuvent s’appliquer aux contrats conclus antérieurement. Chaque achat sur
        le Site est régi par les conditions générales applicables à la date de la commande.
        Nous considérons qu’en validant votre commande, vous acceptez sans réserve nos
        conditions générales de vente après les avoir lues. En accédant au Site,
        vous vous engagez à respecter les Conditions Générales y figurant.
      </p>

      <p class="sub-title col-big-vspace">Identification du vendeur</p>
      <ul>
        <li><p class="tleft">N° de SIREN : 850282443</p></li>
        <li><p class="tleft">Adresse :</p></li>
        <li><p class="tleft">94 rue Jeanne d’Arc</p></li>
        <li><p class="tleft">59000 Lille</p></li>
        <li><p class="tleft">Email : widddi3d@gmail.com</p></li>
      </ul>

      <p class="sub-title col-big-vspace">Emails</p>
      <p>
        Nous nous efforçons de répondre à chaque courrier électronique de
        l’acheteur dans un délai maximum de 72h. L’acheteur ne doit pas hésiter
        à nous contacter pour toute question relative au paiement, à la livraison
        ou à la garantie de son achat. Nous nous ferons un plaisir de trouver
        des solutions adaptées à chaque situation particulière.
        Tous nos mails seront envoyés à l’adresse déposée lors de l’acte d’achat
        ou via le formulaire contact sur le site widddi.com. Merci de vérifier dans
        vos spams si notre réponse ne vous parvient pas.
      </p>

      <p class="sub-title col-big-vspace">Propriété intellectuelle</p>
      <p>
        Widddi propose des créations d’objets. Toutes les créations qui y sont
        présentes sont la propriété de Widddi et de ses créateurs. Elles sont
        protégées au titre des droits d’auteur et de la propriété intellectuelle.
        Toute contrefaçon ou reproduction même partielle est passible de
        poursuites judiciaires.
        Toute utilisation ou reproduction sans autorisation des textes,
        commentaires, photos et articles présents sur ce site sont strictement
        interdites (art.4.335-3).
      </p>

      <p class="sub-title col-big-vspace">Tarifs</p>
      <p>
        Les prix figurant dans le catalogue sont des prix TTC en euros.
        Toutes les autres devises sont acceptées via Paypal uniquement qui
        convertira automatiquement au cours du marché au moment de la validation
        par l’acheteur. Les prix indiqués comprennent les frais de traitement
        de commandes, mais pas la participation aux frais d’emballage, de transport
        et d’expédition. Nous nous réservons le droit de modifier nos prix à
        tout moment mais nous nous engageons à appliquer les tarifs en vigueur
        qui vous auront été indiqués sur le Site à la date de votre commande
        (sous réserve de disponibilité à ce moment). En tant qu’auto-entrepreneur,
        Widddi n’est pas assujetti à la TVA. Cette taxe n’est donc pas applicable,
        conformément à l’article 293B du C.G.I.
      </p>

      <p class="sub-title col-big-vspace">Confirmation de commande</p>
      <p>
        Les informations contractuelles feront l’objet d’une confirmation par voie
        d’e-mail à l’adresse indiquée par l’acheteur au sein du bon de commande.
        Widddi se réserve le droit d’annuler toute commande passée par un client
        avec lequel existerait un litige.
      </p>

      <p class="sub-title col-big-vspace">Paiement</p>
      <p>
        Il s’agit d’une commande avec obligation de paiement, ce qui signifie que
        la passation de la commande implique un règlement de l’acheteur.
        Le paiement de la totalité du prix doit être réalisé lors de la commande.
        Les paiements se font en ligne par carte bancaire, Paypal. Les paiements
        par carte bancaire sont entièrement sécurisés grâce à la plateforme PAYPAL.
        L’acheteur n’est pas obligé d’avoir un compte Paypal pour effectuer
        le règlement. Après avoir cliqué sur la validation du panier “check out”,
        l’acheteur est automatiquement dirigé vers la plateforme Paypal.
        Il lui suffit de renseigner les champs affichés de carte bancaire comme
        pour tout paiement effectué sur internet. (informations Paypal: http://www.paypal.com/fr)
        Pour un paiement international, les frais bancaires sont à la
        charge de l’acheteur.
      </p>

      <p class="sub-title col-big-vspace">Livraison et délais de livraison</p>
      <p>
        Les frais d’emballage, de transport et d’expédition sont à la charge de
        l’acheteur, ils sont calculés automatiquement en fonction de chaque commande,
        ils figurent sur le récapitulatif de votre commande, avant son enregistrement
        et sa validation définitive.
        Les produits disponibles sur le site e-commerce peuvent être livrés en
        Belgique et en France métropolitaine. Pour tout autre lieu de livraison,
        veuillez nous contacter sur widddi3d@gmail.com pour établir un devis.
        La livraison n’est faite qu’après confirmation du paiement par l’organisme
        bancaire du vendeur.
        Les produits commandés sont livrés via La Poste par courrier normal. Nous vous
        fournissons un numéro de suivi de commande du colis lorsque cela est possible.
        Les produits sont livrés à l’adresse indiquée par l’acheteur sur le bon de commande
        et uniquement sur les zones géographiques que nous desservons (Belgique et France
        Métropolitaine). Il est donc très important que l’acheteur vérifie la mise à jour de
        son adresse de livraison sur widddi.com et/ou PayPal.
        Widddi décline toute responsabilité quant à l’allongement des délais de livraison
        du fait du transporteur, notamment en cas de perte des produits, d’intempéries ou de grève.
      </p>

      <p class="sub-title col-big-vspace">Droit de rétractation</p>
      <p>
        Le droit de rétractation ne s’applique qu’aux personnes physiques.
        Conformément aux articles L. 120-20, l’acheteur dispose d’un délai de quatorze
        (14) jours calendaires pour retourner, à ses frais, les produits ne lui convenant
        pas. Ce délai court à compter du jour de la réception de la commande de l’acheteur.
        Toute réclamation doit être adressée par écrit dans la semaine suivant la date
        de réception de la marchandise par courrier (cachet de La Poste faisant foi)
        ou par courrier électronique à widddi3d@gmail.com.
        Après avoir communiqué sa décision de se rétracter, l’acheteur dispose alors de
        14 jours pour renvoyer ou restituer les biens.
        Le retour du produit ne pourra être accepté que pour les produits dans leur
        état d’origine (emballage, accessoires, notice…). Seuls seront repris les produits
        renvoyés dans leur ensemble, dans leur emballage d’origine complet et intact,
        et en parfait état de revente. Tout produit qui aura été abîmé, ou dont leur
        emballage d’origine aura été détérioré, ne sera ni remboursé, ni repris, ni échangé.
        Le produit devra être retourné au vendeur, en Colissimo Recommandé, à l’adresse
        suivante : 94 rue Jeanne d’Arc - 59000 Lille - FRANCE.
        Ce droit de rétractation s’exerce sans pénalité, étant entendu que les frais
        de retour sont à la charge de l’acheteur. Dans le cas d’un échange, la réexpédition
        se fera aux frais de l’acheteur.
        Le vendeur devra rembourser l’acheteur de la totalité des sommes versées, excepté
        les frais de livraison, sans retard injustifié et au plus tard dans les 14 jours
        suivant la date à laquelle il est informé de la décision du consommateur de se
        rétracter. Le vendeur pourra différer le remboursement jusqu’à récupération des
        biens ou jusqu’à ce que l’acheteur ait fourni une preuve de l’expédition de ces
        biens, la date retenue étant celle du premier de ces faits. En l’absence de cette
        preuve, aucun échange ou remboursement ne pourra être effectué en cas de perte du
        colis.
        En cas d’exercice du droit de rétractation, Widddi fera tous les efforts pour
        rembourser l’acheteur dans un délai de trente jours.
        Toutefois, conformément à l’article L-121-20 du Code de la consommation ce
        délai de rétractation ne pourra pas être exercé pour les fournitures de biens
        confectionnés à la demande de l’Acheteur ou nettement personnalisés.
      </p>

      <p class="sub-title col-big-vspace">Force majeure</p>
      <p>
        Toutes circonstances indépendantes de la volonté des parties empêchant l’exécution
        dans des conditions normales de leurs obligations sont considérées comme des causes
        d’exonération des obligations des parties et entraînent leur suspension.
        La partie qui invoque les circonstances visées ci-dessus doit avertir immédiatement
        l’autre partie de leur survenance, ainsi que de leur disparition.
        Seront considérés comme cas de force majeure tous faits ou circonstances irrésistibles,
        extérieurs aux parties, imprévisibles, inévitables, indépendants de la volonté des
        parties et qui ne pourront être empêchés par ces dernières, malgré tous les efforts
        raisonnablement possibles. De façon expresse, sont considérés comme cas de force majeure
        ou cas fortuits, outre ceux habituellement retenus par la jurisprudence des cours et
        des tribunaux français : le blocage des moyens de transports ou d’approvisionnements,
        tremblements de terre, incendies, tempêtes, inondations, foudre, l’arrêt des
        réseaux de télécommunication ou difficultés propres aux réseaux de télécommunication
        externes aux clients.
        La partie touchée par de telles circonstances en avisera l’autre dans les dix jours
        ouvrables suivant la date à laquelle elle aura eu connaissance.
        Les parties se rapprocheront pour examiner l’incidence de l’événement et convenir des
        conditions dans lesquelles l’exécution du contrat sera poursuivie. Si le cas de
        force majeur a une durée supérieure à trois mois, les présentes conditions
        générales pourront être résiliées par la partie lésée.
      </p>

      <p class="sub-title col-big-vspace">Loi applicable</p>
      <p>
        Les présentes conditions générales sont soumises à la loi française.
        Il en est ainsi pour les règles de fonds comme pour les règles de forme.
        En cas de litige ou de réclamation, l’acheteur s’adressera en priorité
        à la société Widddi pour obtenir une solution amiable.
      </p>

      <p class="sub-title col-big-vspace">Protection des données personnelles</p>
      <p>
        Les informations nominatives recueillies sont indispensables pour le
        traitement et l’acheminement des commandes ainsi que l’établissement
        des factures.
        Les données nominatives ne sont en aucun cas transmises à des tiers.
      </p>
    </div>
    </template>
  </TemplateBasic>
</template>

<script>
import { TemplateBasic } from '@/components/template';

export default {
  name: 'cgu',
  components: { TemplateBasic },
};
</script>
